import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.css";

const ServiceProgramInfo: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.infoContainer}>
      <h2 className={styles.title}>{t('service_program.info_title')}</h2>
      <p className={styles.paragraph}>
        {t('service_program.info_paragraph_1')}
      </p>
      {/* <p className={styles.paragraph}>
        🔧 <b>{t('service_program.info_why_title')}</b>
      </p>
      <p className={styles.paragraph}>
        🌐 {t('service_program.info_why_fault')}
      </p>
      <p className={styles.paragraph}>
        🔗 {t('service_program.info_why_error')}
      </p> */}
    </div>
  );
};

export default ServiceProgramInfo;
